import React, { useRef, useState } from 'react';
import { Button, Stack } from '@hover/blueprint';
import { ScrollerButton } from '../../v2/components/partners/ScrollerButton';
import { FeaturedPartners } from '../../v2/components/partners/FeaturedPartners';
import { Manufactors } from '../../v2/components/partners/Manufactors';
import { Integrations } from '../../v2/components/partners/Integrations';
import Layout from '../../v2/components/common/layout';
import Hero from '../../v2/components/partners/Hero';
import WantToPartner from '../../v2/components/partners/WantToPartner';
import { UtilityMenuBanner } from '../../v2/components/common';

const PartnersPage = () => {
  const [isNavbarDocked, setIsNavbarDocked] = useState(true);
  const manufacRef = useRef<HTMLDivElement>(null);
  const featuredRef = useRef<HTMLDivElement>(null);
  const integRef = useRef<HTMLDivElement>(null);

  return (
    <Layout
      title="Partners"
      navbarBackgroundColor="transparent"
      onNavbarStateChange={state => setIsNavbarDocked(state === 'docked')}
      isNavbarWhite={!isNavbarDocked}
      bannerElement={<UtilityMenuBanner />}
    >
      <Hero />

      <Stack
        mt="100px"
        flexDir="row"
        d={{ base: 'none', desktop: 'flex' }}
        gap={7}
        p={7}
        alignItems="center"
        bgColor="primary.50"
        w="100%"
        justifyContent="center"
      >
        <ScrollerButton anchorRef={manufacRef}>Our Partners</ScrollerButton>
        <ScrollerButton anchorRef={featuredRef}>
          Why our Partners choose us
        </ScrollerButton>
        <ScrollerButton anchorRef={integRef}>Our Integrations</ScrollerButton>
        <Button color="primary" size="large">
          Become A Partner
        </Button>
      </Stack>

      <div ref={manufacRef}>
        <Manufactors />
      </div>

      <div ref={featuredRef}>
        <FeaturedPartners />
      </div>

      <div ref={integRef}>
        <Integrations />
      </div>
      <WantToPartner />
    </Layout>
  );
};

export default PartnersPage;
